import React, { useContext, useMemo } from "react";
import { Typography } from "@mui/material";
import { useEditor } from "@craftjs/core";
import { SourceBindContext } from "../sources/sourceBindContext";
import { BlockStyleFn, RichEditorStyleMap } from "../../../MaterialTripList/utils/editor/editor";
import { customColors } from "../../../MaterialTripList/utils/editor/customColors";
import { RichEditorFontSizeStylesMap } from "../../../MaterialTripList/utils/editor/richEditorFontSizeControl";

export function TextSourceBindDecorator(props: any): React.ReactNode {
    const { isEditorEnabled } = useEditor((state) => ({
        isEditorEnabled: state.options.enabled,
    }));
    const sourceBindContext = useContext(SourceBindContext);
    const { label } = props.contentState.getEntity(props.entityKey).getData();
    const value = useMemo(() => {
        if (isEditorEnabled) {
            return null;
        }
        const data = sourceBindContext.datas.find((item) => {
            return item.label === label;
        });
        return data?.value;
    }, [isEditorEnabled, sourceBindContext.datas, label]);
    const quotationCode = JSON.parse(localStorage.getItem('config') ?? '{}').quotation_code;
    const block = props.contentState.getBlockForKey(props.blockKey);
    const styles = {
        ...RichEditorStyleMap,
        ...RichEditorFontSizeStylesMap,
        ...(quotationCode ? customColors[quotationCode] : null)
    };
    const computedStyles = Array.from(block.getInlineStyleAt(0)).map((key) => {
        return styles[key as string];
    });
    if (isEditorEnabled) {
        return (
            <Typography
                variant="body2"
                color="InfoText"
                sx={{
                    textDecoration: 'underline',
                }}
                component="span"
            >
                {props.children}
            </Typography>
        );
    }

    return (
        <span
            style={
                computedStyles.reduce((prev, current) => {
                    return {
                        ...prev,
                        ...current
                    }
                }, {} as Record<string, unknown>)
            }
            className={
                BlockStyleFn(block)
            }
        >
            {value}
        </span>
    );
}